export const CONTRACT_TYPES = {
    "AUTOMATED": "إلكتروني",
    "FILE": "ورقي"
};